import React from "react";
import Button from "../../components/shared/button";
import { usePopup } from "providers/PopupProvider";
import { Popup } from "components/popups/Popup";

const PopupDemo: React.FC<
  React.PropsWithChildren<{
    fullscreen?: boolean;
    title?: string;
    buttonText?: string;
    coloredTitle?: boolean;
  }>
> = ({ children, fullscreen = false, title, buttonText, coloredTitle }) => {
  const { openPopup } = usePopup();
  return (
    <>
      <Button
        large
        outline
        onClick={() =>
          openPopup(
            <Popup
              title={title ?? "popup Demo"}
              fullscreen={fullscreen}
              coloredTitle={coloredTitle}
            >
              {children}
            </Popup>
          )
        }
      >
        <text>
          {buttonText ?? `Open ${fullscreen ? "Full Screen" : ""} Window`}
        </text>
      </Button>
    </>
  );
};
export default PopupDemo;
